<template>
    <Head>
        <title>Wakaf Pahang - Maklumat pewakaf bagi {{ receipt.nama }}</title>
        <link rel="shortcut apple-touch-icon icon" fetchpriority="high" as="image" :href="img_favicon" type="image/png">
    </Head>
    <div class="container mt-lg-5">
        <div class="d-flex justify-content-end my-3">
            <a v-if="officer_uri !== undefined" class="btn btn-warning me-2 d-print-none" :href="officer_uri" target="_blank"><i class="fa-solid fa-money-bill-transfer pe-2"></i>Wakaf lagi</a>
            <button class="btn btn-primary me-2 d-print-none" @click="openAction('print')"><font-awesome-icon :icon="faPrint" /></button>
            <button class="btn btn-danger d-print-none" :class="{'d-none': showCloseBtn}" @click="openAction('close')">
                <font-awesome-icon :icon="faXmark" /></button>
            <button v-if="print_btn ==='j2me'" class="btn btn-warning d-print-none" @click="openAction('link')">
                <font-awesome-icon :icon="faPrint" /> Resit Rasmi
            </button>
        </div>
        <div class="d-flex align-items-center justify-content-center">
            <img :src="data.img_wakafpahang" alt="MUIP Pekan Pahang" class="logo">
        </div>
        <div class="d-flex align-items-center justify-content-center flex-column">
            <span class="titleKaedah text-center">KAEDAH-KAEDAH DANA WAKAF 2015</span>
            <span class="titleKaedah text-center">RESIT PENGESAHAN BAYARAN</span>
        </div>
        <div class="d-flex justify-content-between mt-1">
            <p class="label">DITERIMA DARIPADA :</p>
            <p class="d-inline float-end">No: <span class="label wakafNumber">{{ receipt.noresit }}</span></p>
        </div>
        <div class="d-flex flex-column">
            <span class="label fw-bold">{{ receipt.nama }}</span>
            <span class="label fw-bold">({{ receipt.nokp }})</span>
        </div>
        <div class="row">
            <div class="col">
                <div class="table-responsive">
                    <table class="table tableLabel">
                        <thead>
                        <tr>
                            <th class="has-text-centered" scope="col">No</th>
                            <th scope="col">Nama Pemilik</th>
                            <th scope="col">Jenis Pemilikan</th>
                            <th scope="col">Projek</th>
                            <th scope="col">Daerah</th>
                            <th scope="col" class="text-center">Bil. Unit</th>
                            <th scope="col" class="text-center">Perkara</th>
                            <th scope="col" class="text-center">Amaun (RM)</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(item, index) in transaction">
                            <td class="text-center">{{ index + 1 }}</td>
                            <td v-if="item.JenisPemilikan === 'Mewakili Orang Meninggal'"> ARWAH {{
                                    item.NamaPemilik
                                }}
                            </td>
                            <td v-else> {{ item.NamaPemilik }}</td>
                            <td>{{ item.JenisPemilikan }}</td>
                            <td v-if="item.project !== null">{{ item.project }}</td>
                            <td v-else>Wakaf Tunai</td>
                            <td>{{ item.district }}</td>
                            <td class="text-center">{{ item.Unit }}</td>
                            <td class="text-center">Sumbg. Tunai</td>
                            <td class="text-center">{{ sumFormatWithoutCurrency(item.Amaun) }}</td>
                        </tr>
                        <tr>
                            <td colspan="7" style="text-align: right;"><b>Jumlah (RM) </b></td>
                            <td class="text-center" colspan="1">{{
                                    sumFormatWithoutCurrency(calculateSum(transaction))
                                }}
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="d-flex justify-content-between mb-3">
            <span class="label">KAEDAH BAYARAN : <b>{{ paymenttype }}</b></span>
            <span class="label text-end">Nama Pegawai : <b>{{ officer }}</b></span>
        </div>
        <div class="d-flex justify-content-around">
                <span class="label" style="flex-basis: 50%;">"Sumbangan derma dikecualikan daripada cukai pendapatan di bawah Seksyen 44 (6)
                    Akta Cukai Pendapatan 1967 No. Rujukan LHDN. 01/35/42/51/179-6"</span>
            <span class="label text-end" style="flex-basis: 50%;">Dokumen ini adalah cetakan komputer.<br>Tandatangan
                    tidak diperlukan.</span>
        </div>
        <div class="row mt-3">
            <div class="col">
                <p class="label">Tarikh Bayaran : {{ formatDateWithSeconds(date) }}</p>
            </div>
        </div>
        <footer class="footer-print">
            <hr class="divider">
            <div class="d-flex align-items-center justify-content-center">
                <p class="text-center fst-italic label">Resit ini hanya untuk rujukan pihak pewakaf, tidak sah
                    bagi tujuan kegunaan LHDN.
                    Sila hubungi Pusat Wakaf Pahang untuk mendapatkan resit rasmi.</p>
            </div>
            <div class="d-flex align-items-center justify-content-center">
                <p class="text-center label">PEJABAT WAKAF PAHANG : No 111A, Tingkat 1, Bangunan MUIP, Jalan
                    Mahkota,
                    25000 Kuantan, Pahang Darul Makmur.<br>Tel : 09–514 5151 | Fax : 09–516 5150 | info@wakafpahang.my
                </p>
            </div>
        </footer>
    </div>
</template>

<script setup lang="ts">
import {sumFormatWithoutCurrency, formatDateWithSeconds} from "../../utils/utils";
import {onMounted, ref} from "vue";
import Swal from "sweetalert2";
import "animate.css";
import {Head} from "@inertiajs/vue3";
import { faPrint, faXmark, faMoneyBillTransfer} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
library.add(faPrint, faXmark, faMoneyBillTransfer);

const data = defineProps<{
    btn_sw?: string,
    img_wakafpahang: string,
    img_favicon: string,
    transaction: Itransaction[],
    receipt: {
        noresit: number,
        nama: string,
        nokp: string

    },
    paymenttype: string,
    officer: string,
    success?: string,
    date: string,
    print_btn?: string,
    print_link?: string,
    officer_uri?: string,
}>();

interface Itransaction {
    JenisPemilikan: string,
    NamaPemilik:string,
    Unit: number,
    Amaun: number,
    project: string,
    district: string
}
const calculateSum = (transaction: Itransaction[]) => transaction.reduce((prev, curr) => prev + curr.Amaun, 0);

const openAction = (act: String): void => {
    switch (act) {
        case "link":
            window.open(data.print_link + '?neorage=rage');
            break;
        case "print":
            window.print();
            break;
        case "close":
            window.close();
            break;
    }
}

const showCloseBtn = ref(true);
onMounted(() => {
    if (window.opener !== null) {
        showCloseBtn.value = false;
    }
    if (data.success) {
        thankYouModal();
    }
});

const thankYouModal = () => {
    Swal.fire({
        title: 'جَزَاكُمُ اللهُ خَيْرًا كَثِيْرًا وَجَزَاكُمُ اللهُ اَحْسَنَ الْجَزَاء',
        html: 'Semoga Allah S.W.T. menganugerahkan sebaik-baik ganjaran ke atas harta yang diwakafkan dan diberikan keberkatan serta kebahagiaan yang berkekalan kepada anda.',
        icon: 'info',
        confirmButtonText: 'Tutup',
        timer: 10000,
        timerProgressBar: true,
        showClass: {
            popup: 'animate__animated animate__tada'
        },
        hideClass: {
            popup: 'animate__animated animate__fadeOutDown'
        }
    }).then(function () {
        const url = document.URL;
        const domain = url.split('?')[0];
        let qs = url.split('?')[1];
        // url = url.split('?')[0];
        const params = new URLSearchParams(qs);
        params.delete("success");
        history.replaceState({}, '', domain + "?" + params.toString());
    });

}
</script>

<style scoped>
.wakafNumber {
    padding: 0 5px 0 5px;
    border: solid 1px #000000;
}

@media print {
    .logo {
        width: 200px;
        height: 57px;
    }

    .label, .tableLabel {
        font-size: 11px;
    }

    .titleKaedah {
        font-size: 15px;
    }

    .divider {
        border-top: 1px solid #8c8b8b;

    }

    .footer-print {
        position: absolute;
        bottom: 0;
    }
}

@media screen and (min-width: 769px) {
    .logo {
        width: 200px;
        height: 57px;
    }

    .label, .titleKaedah {
        font-size: 1.25rem !important;
    }

    .tableLabel {
        font-size: 1rem !important;
    }
}

@media screen and (max-width: 768px) {
    .logo {
        width: 200px;
        height: 57px;
    }
}
</style>
